import admin_dashboard from './admin-dashboard';
import dashboard from './dashboard';
// import student from './student-menu';
import utilities from './utilities';

// // ==============================|| MENU ITEMS ||============================== //

const menuItems = {
    items: [dashboard, utilities]
};

export default menuItems;

// ===============================

// import { useSelector } from "react-redux";

// import dashboard from "./dashboard";

// import utilities from "./utilities";

// import admin_dashboard from "./admin-dashboard";

// import superUtilities from "./super-admin-utilities";

// const MenuItems = () => {

//   // Get user role from Redux state

//   const userRole = useSelector((state) => state.user.paraAdmin_user_Info?.role); // Adjust based on your Redux structure

//   // console.log("User role", userRole);

//   let allowedItems = [];

//   if (userRole === "admin") {

//     allowedItems.push(admin_dashboard, utilities); // Only Admin sees Dashboard

//   } else if (userRole === "superadmin") {

//     allowedItems.push(dashboard, superUtilities, utilities); // Student doesn't see Dashboard

//   }

//   return { items: allowedItems };

// };

// export default MenuItems;


// =============================

// import { useSelector } from "react-redux";
// import dashboard from "./dashboard";
// import utilities from "./utilities";
// import admin_dashboard from "./admin-dashboard";
// import superUtilities from "./super-admin-utilities";

// const MenuItems = () => {
//   // Get user role from Redux state
//   const userRole = useSelector((state) => state.user.paraAdmin_user_Info?.role); // Adjust based on your Redux structure
//   // console.log("User role", userRole);

//   let allowedItems = [];

//   if (userRole === "admin") {
//     allowedItems.push(admin_dashboard, utilities(userRole)); // Only Admin sees Dashboard
//   }

//   return { items: allowedItems };
// };

// export default MenuItems;
